import { Link as RouterLink } from '@exam-management/router';
import { Link } from '@shared/components';

import type { ErrorPublicationResultDetail } from '../../types';

interface QuestionRefCodeLinkProps {
  detail: ErrorPublicationResultDetail;
}

export default function QuestionRefCodeLink(props: Readonly<QuestionRefCodeLinkProps>) {
  const { detail } = props;
  const { questionRefCode, questionId, questionGroupId, questionGroupType, qBankStructureId } =
    detail;

  if (!questionId || !qBankStructureId || !questionGroupType) return <>{questionRefCode}</>;

  if (questionGroupType === 'ITEM_SET') {
    if (!questionGroupId) return <>{questionRefCode}</>;

    return (
      <Link
        component={RouterLink}
        color='info'
        to='/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId'
        params={{
          structureId: qBankStructureId,
          questionId: questionGroupId,
          subQuestionId: questionId,
        }}
        target='_blank'
        rel='noopener noreferrer'
      >
        {questionRefCode}
      </Link>
    );
  }

  // SINGLE and LOT_OF_QUESTION both open the single question detail page
  return (
    <Link
      component={RouterLink}
      color='info'
      to='/qbank-structures/:structureId/qcontents/single/:contentId'
      params={{ structureId: qBankStructureId, contentId: questionId }}
      target='_blank'
      rel='noopener noreferrer'
    >
      {questionRefCode}
    </Link>
  );
}
